module.exports = __webpack_public_path__ + "img/W-M38.a43704e6.jpg";